require('./style.less');


var Marionette = require('marionette'),
    $ = require('jquery'),
    fvChannel = require('glRadio').channel('FV'),
    CRE_Download_Defaults = require('../../viewer/creDownloadDefaults'),
    UnrenderablePgsView = require('./unrenderablePages/view');  /* collection view generated if docHasNoRenderable Pgs (if mixed, you get the dropdown list */

$.fn.creRequest = $.fn.creRequest || require('CRE');


module.exports = Marionette.ItemView.extend({
    className: 'FV-pdfMode FV-paneContentWr',
    template: require('./pdfContainer.hbs'),
    initialize: function(options) {

        this.lCh = options.lCh;
        this.lCh.reply({
            pdfWrapper: function() { return this.ui.pdfWrapper; }
        }, this);

        this.renderCancelled = false;//flag for requested after a cancel by the user

    },
    serializeData: function() {
       return {
           docHasNoPDFRenderablePgs: this.options.docHasNoPDFRenderablePgs
       };
    },
    onRender: function() {
        this.unwrap();
        this.options.docHasNoPDFRenderablePgs && this._createNonRenderableCollectionView();
    },
    ui: {
        pdfHolder:              '#iframeViewer', // either iframe or object
        pdfWrapper:             '.iframeWr', // starts invisible
        downloadCancelledWr:    '#dlCancelledPDF',
        reloadBtn:              '#reloadPDF'
    },
    events:  {
        'click @ui.reloadBtn': 'loadPDFDocument'
    },
    loadPDFDocument: function() {

        var vCh = this.options.vChannel;
        var self = this,
            activeDoc = vCh.request('activeDocument'),
            renderRequest = activeDoc.docRenderRequest('pdf','pdf'), /* just the active document */
            creOptions = _.extend( {},
                renderRequest,
                {
                    fileName: activeDoc.documentName('pdf', 1) // Note: using first file name if more requested (pdf)
                }, new CRE_Download_Defaults({
                    isPDF: true,
                    vChannel: vCh,
                    startCB: function() {
                        self.renderCancelled = false;
                        self.ui.downloadCancelledWr.addClass('hide'); //hide on start in case was cancelled
                    },
                    completeCB:  _.bind(this.loadSuccess, this), //TODO: the download view could get first
                    errorCB: _.bind(this.loadError, this),
                    cancelCB: _.bind(this.renderCancelledByUser, this),
                    dontShowErrMsg: true,
                    inlinePDF: true
            })
        );

        $.fn.creRequest(creOptions);
    },
    loadSuccess: function(data) {

        !this.ui.pdfHolder.attr && this.bindUIElements();

        this.ui.pdfHolder.attr( 'src' ,
            this.options.vChannel.request('getPdfUrlToLoadInFrame', data )
        );

        this.ui.pdfWrapper.removeClass('invisible');
        this.options.vChannel.command('setPDFisLoaded');

    },
    loadError: function(errMsg) {

        $.when( fvChannel.request('auth')._keepAlive() ).then( _.bind( function(isAuthenticated) {
            if (isAuthenticated) {
                //TODO: print in view w/retry
                this.options.vChannel.trigger('alert:show', {
                    type: 'error',
                    shortMessage: 'Error loading PDF',
                    detailedMsg: errMsg

                });
            } else {  //set state to auth screen: user timed out -- if successfuly will reload (continueLoadingImgPostAuthorization)
                fvChannel.command('unauthorizedLogout');
            }
        }, this));
    },
    renderCancelledByUser: function() {
        this.renderCancelled = true;
        this.ui.downloadCancelledWr.removeClass('hide');
    },
    _createNonRenderableCollectionView: function() {
        var vCh = this.options.vChannel;
        this.$el.append( new UnrenderablePgsView({
            collection: vCh.request('unrenderablePDFModePgs'), //here would be all
            vChannel: vCh,
            viewMode: 'pdf'
        }).render().el );
    },
    /*
    * Note: quick fix: DVBC-807 -- here, if request never made, .cancel will not exist -- so check for it.
    * Real fix is to change arch of the plugin AND have a cancel of all possible requests on reset, where this would be destroyed --
    * this would be the CRE queue -- shouldn't be done here.
    * Only other place called now is in the CRE - defaults, which this overrides -- (on cancel)
    * */
    onBeforeDestroy: function() {
        var fnCancelReq = $.fn.creRequest.cancel;
        fnCancelReq && fnCancelReq({byForce: true});
        this.lCh.reset();
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewModes/pdfMode/pdfContainer.js
 ** module id = 475
 ** module chunks = 0
 **/